// import Multiselect from "multiselect-react-dropdown";
import React from "react";
import Select, { components } from "react-select";
import classes from "./Dropdown.module.scss";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ cursor: "pointer" }}
          disabled={props.isDisabled}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const Dropdown = ({
  name,
  onChange,
  placeholder,
  options,
  isRequired = false,
  selectedValue,
  label,
  light,
  validationLabel = "",
  height = "5.1",
  width = "25",
  isMulti = false,
  maxSelected = 1,
  isLimit = false,
  isDisabled = false,
  isInputDisabled = false,
}) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      borderradius: "0.1",
      height: 100 + "%",
      cursor: "pointer",
      minHeight: "5.1rem",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#0001" : "",
        cursor: "pointer",
        color: isSelected ? "black" : "",

        cursor: "pointer",
      };
    },
  };

  return (
    <div className={classes.dropdown}>
      {label && (
        <div
          style={{
            display: "flex",
            width: width + "rem",
          }}
        >
          <label
            style={{ color: light ? "#707070" : "#404040" }}
            className={isRequired ? classes.inputLabel : classes.labels}
          >
            {label}
          </label>

          {isMulti && isLimit && (
            <div className={classes.validationLabel}>
              <div>
                (Max: {maxSelected} {validationLabel})
              </div>
            </div>
          )}
        </div>
      )}
      <div
        className={classes.dropdown_main}
        style={{
          width: width + "rem",
          // height: height + "rem",
        }}
      >
        {isMulti ? (
          isLimit ? (
            <Select
              className="basic-single"
              classNamePrefix="select"
              options={options}
              placeholder={placeholder}
              styles={customStyles}
              onChange={onChange}
              closeMenuOnSelect={false}
              isOptionDisabled={() => selectedValue?.length === maxSelected}
              hideSelectedOptions={false}
              components={{
                Option,
              }}
              value={selectedValue}
              isDisabled={isDisabled}
              isMulti
            />
          ) : (
            <Select
              className="basic-single"
              classNamePrefix="select"
              options={options}
              placeholder={placeholder}
              styles={customStyles}
              onChange={onChange}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{
                Option,
              }}
              value={selectedValue}
              isMulti
            />
          )
        ) : (
          <select
            className={classes.dropdownSelect}
            name={name}
            value={selectedValue}
            onChange={onChange}
            style={{
              width: width + "rem",
              height: height + "rem",
              cursor: "pointer",
              backgroundColor: isInputDisabled ? "hsl(0deg 0% 90%)" : "",
            }}
            disabled={isInputDisabled}
          >
            <option
              value=""
              className={classes.dropdownPlaceholder}
              disabled
              selected
            >
              {placeholder}
            </option>
            {options?.map((item, key) => (
              <>
                <div style={{background: "red", position: "absolute", width: "500px", height: "500px", top: "0"}}>
                  <input type="text" />
                </div>
                <option
                  className={classes.dropdownOptions}
                  key={key}
                  value={item.value}
                >
                  {item.label}
                </option>
              </>
            ))}
          </select>
        )}

        {/* <Multiselect
          id="css_custom"
          options={options}
          displayValue="label"
          showCheckbox
        /> */}
      </div>
    </div>
  );
};

export default Dropdown;
